import { useCallback } from 'react';
import { FeatureFlagName } from 'shared/enums';
import useFeatureFlag from 'shared/hooks/useFeatureFlag';
import { OttoLabsClinicSetting, ottoLabsClinicSettingsMap } from '../constants';

type UseOttoLabsClinicSettingsResult = {
  isEnabled: boolean;
  toggleFeatureFlag: () => void;
  setting?: OttoLabsClinicSetting;
};

const useOttoLabsClinicSettings = (flag: FeatureFlagName): UseOttoLabsClinicSettingsResult => {
  const { isFeatureEnabled, addFeatureFlag, removeFeatureFlag, isFeatureGlobal } = useFeatureFlag();
  const isEnabled = isFeatureEnabled(flag);
  const isGlobal = isFeatureGlobal(flag);

  // Ensure that the displayed settings are specific to a clinic level.
  // This is important because toggling the state of non-clinic level settings would not have any effect.
  const setting = isGlobal === false ? ottoLabsClinicSettingsMap[flag] : undefined;

  const toggleFeatureFlag = useCallback(() => {
    if (isEnabled) {
      removeFeatureFlag(flag);
    } else {
      addFeatureFlag(flag);
    }
  }, [addFeatureFlag, flag, isEnabled, removeFeatureFlag]);

  return {
    isEnabled,
    setting,
    toggleFeatureFlag,
  };
};

export default useOttoLabsClinicSettings;
